import * as R from 'ramda';

/**
 * Process reconsignment state into a sanitized object with safe paths
 *
 * @param {Object} reconsignmentState The raw reconsignment state
 * @returns {Object} Sanitized reconsignment state
 */
const getSafeReconsignmentState = reconsignmentState => {
  if (!reconsignmentState) return {};

  return {
    consignmentStatus: R.path(['consignmentStatus'], reconsignmentState),
    inventoryOwner: {
      companyCustomerIdName: R.path(['inventoryOwner', 'customerIdName'], reconsignmentState),
      customerNameShort: R.path(['inventoryOwner', 'customerNameShort'], reconsignmentState),
      dataCompanyId: R.path(['inventoryOwner', 'dataCompanyId'], reconsignmentState),
    },
    inventoryStatus: R.path(['inventoryStatus'], reconsignmentState),
    origin: reconsignmentState.origin
      ? R.map(origin => ({ originId: origin.originId }), reconsignmentState.origin)
      : [],
    product: {
      productId: R.path(['product', 'productId'], reconsignmentState),
      productName: R.path(['product', 'productName'], reconsignmentState),
    },
    rvp: R.prop('rvp', reconsignmentState),
  };
};
export default getSafeReconsignmentState;
